export const APP_MINI_NAME = "Rentalsols"